/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { CategoryDto } from './categoryDto';
import { PersonalizationDto } from './personalizationDto';
import { PlaceInformationDto } from './placeInformationDto';
import { LocationInfoDto } from './locationInfoDto';


export interface CompanyDto { 
    id?: number;
    uuid?: string;
    companyName?: string;
    companyNo?: string;
    vat?: string;
    logo?: string;
    phone1?: string;
    phone2?: string;
    email?: string;
    contactFirstName?: string;
    contactLastName?: string;
    loyaltyProgramStatus?: CompanyDto.LoyaltyProgramStatusEnum;
    hqLocation?: LocationInfoDto;
    category?: CategoryDto;
    pointsPerLomyCoin?: number;
    loyaltyName?: string;
    showCompanyOffices?: boolean;
    qrCodeAvailable?: boolean;
    personalization?: PersonalizationDto;
    placeInformation?: PlaceInformationDto;
    dailyLimit?: number;
}
export namespace CompanyDto {
    export type LoyaltyProgramStatusEnum = 'INVALID' | 'IN_PROGRESS' | 'VALID';
    export const LoyaltyProgramStatusEnum = {
        Invalid: 'INVALID' as LoyaltyProgramStatusEnum,
        InProgress: 'IN_PROGRESS' as LoyaltyProgramStatusEnum,
        Valid: 'VALID' as LoyaltyProgramStatusEnum
    };
}


